import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { CardContent, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { useContent, useGlobalClient } from 'hooks';

import {
  CommentCount,
  Date,
  EngagePublic,
  EngagementCount,
  ReactionCount,
  ShareCount,
  ShareSocial,
} from '../widgets';
import { isEngageable } from '../helpers';

const useStyles = makeStyles(theme => ({
  content: {
    paddingBottom: theme.spacing(2),
  },
  count: {
    marginRight: theme.spacing(2),
  },
}));

const MetaNoAuthToShare: FC = () => {
  const classes = useStyles();
  const content = useContent();
  const { public_post_force_login } = useGlobalClient();
  const { t } = useTranslation();

  const { content_id, publish_at, reaction_count, comment_count, share_count, engage_count } =
    content;
  const showEngage = isEngageable(content);
  const showCounts = reaction_count + comment_count + share_count + engage_count;

  function renderCounts() {
    return (
      <Grid container justify="flex-start" alignItems="center">
        <Grid item className={classes.count}>
          <ReactionCount />
        </Grid>
        <Grid item className={classes.count}>
          <CommentCount />
        </Grid>
        <Grid item className={classes.count}>
          <ShareCount />
        </Grid>
        {showEngage && (
          <Grid item>
            <EngagementCount />
          </Grid>
        )}
      </Grid>
    );
  }

  return (
    <Fragment>
      <CardContent>
        <Grid container alignItems="center">
          <Date contentId={content_id} publishAt={publish_at} />
        </Grid>
      </CardContent>
      {!!showCounts && <CardContent>{renderCounts()}</CardContent>}
      <CardContent className={classes.content} hidden={public_post_force_login}>
        <Grid container alignItems="center" justify="space-between">
          <Grid container item alignItems="center" spacing={1}>
            {!showEngage && (
              <Fragment>
                <Grid item xs>
                  <Typography>{t('components:shareTo')}</Typography>
                </Grid>
                <Grid item>
                  <ShareSocial />
                </Grid>
              </Fragment>
            )}
            {showEngage && (
              <Grid container item justify="flex-end">
                <EngagePublic />
              </Grid>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Fragment>
  );
};

export default MetaNoAuthToShare;
